module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-medium-1b5871d076ad4d8acab6ccc982e806cd.svg";